import { NestedQuota } from '../../../shared/interfaces/quota.interface';
import { AllocatedNestedQuota } from './allocated-nested-quota';
import {
  EqualValueAllocation,
  FirstQuotaAllocation,
  HighestPercentAllocation,
  NestingAudit,
} from './nesting-audit';

export class NestedAllocation {
  private _allocatedQuotas: AllocatedNestedQuota[] = [];

  public get allocations(): AllocatedNestedQuota[] {
    if (!this._allocatedQuotas.length) {
      this._allocatedQuotas = this._nestedQuotas.map(
        (quota) => new AllocatedNestedQuota(quota)
      );
    }

    return this._allocatedQuotas;
  }

  constructor(
    private readonly _goal: number,
    private readonly _nestedQuotas: NestedQuota[]
  ) {}

  public audit(): NestedQuota[] {
    let offset = this._offset();

    if (offset === 0) {
      return this._nestedQuotas;
    }

    if (Math.abs(offset) > this._nestedQuotas.length) {
      const equalAllocation = new EqualValueAllocation(this.allocations);
      equalAllocation.distribute(offset);
      offset = this._offset();
    }

    const allocation = this._distribution(offset);
    allocation.distribute(offset);

    return this._nestedQuotas;
  }

  private _offset(): number {
    const total = this.allocations.reduce(
      (acc, quota) => acc + quota.allocation(),
      0
    );

    return this._goal - total;
  }

  private _distribution(offset: number): NestingAudit {
    const highest = this.allocations.reduce(
      (acc, next) => Math.max(acc, next.percentage()),
      0
    );

    if (highest === 2 && Math.abs(offset) === 1) {
      return new FirstQuotaAllocation(this.allocations);
    }

    return new HighestPercentAllocation(this.allocations);
  }
}
